import React from "react";
import { TableRow, TableCell, withStyles, IconButton } from "@material-ui/core";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@material-ui/icons";

const styles = (theme) => ({
  proNumberContainer: {
    height: "24px",
    backgroundColor: theme.statusHeadBGColor,
  },
  driverStatusHeaderCell: {
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "10px",
    color: theme.proNumbers,
  },
  proNumbers: {
    float: "left",
    paddingTop: 3,
    paddingLeft: "10px",
    overflow: "hidden",
    lineHeight: "17px",
    width: "210px",
    textOverflow: "ellipsis",
  },
  expand: {
    marginLeft: "auto",
    color: theme.proNumbers,
    float: "right",
    padding: 0,
    margin: "0 7 0 0",
  },
});

class ShowProNumbers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  render() {
    const { classes, proNumberList } = this.props;
    return (
      <TableRow className={classes.proNumberContainer}>
        <TableCell colSpan={2} className={classes.driverStatusHeaderCell}>
          {this.state.expanded ? (
            <div className={classes.proNumbers}>
              Pro#: {proNumberList.join(", ")}
            </div>
          ) : (
            <div className={classes.proNumbers}>
              Pro#: {proNumberList.slice(0, 2).join(", ")}
            </div>
          )}
          {proNumberList.length > 2 && (
            <IconButton
              className={classes.expand}
              onClick={this.handleExpandClick}
            >
              {this.state.expanded ? (
                <ExpandLessIcon className={classes.expandIcon} />
              ) : (
                <ExpandMoreIcon className={classes.expandIcon} />
              )}
            </IconButton>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(styles)(ShowProNumbers);
